import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get, has, isNumber, head } from 'lodash'
import queryString from 'query-string'

import ChangeCalculatorForm from '../components/ChangeCalculatorForm'
import { getTotal } from '../selectors/cart'
import { makeGetOrder } from '../selectors/order'
import { makeGetRemoteOrderTotal } from '../selectors/orderTotalRemote'
import { startCashOrder, startCloseTabOrderWithCash, applyOrderExemptions, addTenderOnOrder } from '../actions/order'
import { resolveNextAmountInCents } from '../utils/orderUtils'

const mapStateToProps = (state, ownProps) => {
  const orderId = head(ownProps?.match?.params?.orderId?.split('?'))
  const tenderAmountInCents = ownProps?.history?.location?.state?.tenderAmountInCents ?? 0
  const getOrder = makeGetOrder()
  const order = getOrder(state, orderId)
  const exemptionOverrides = orderId !== undefined ? order?.exemptionOverrides : ownProps?.history?.location?.state?.exemptionOverrides ?? {}
  const localOrderTotal = orderId !== undefined ? order?.orderTotalFromOrder?.totalAmountInCents ?? 0 : getTotal(state)
  const selectRemoteOrderTotal = makeGetRemoteOrderTotal()
  const remoteOrderTotal = selectRemoteOrderTotal(state)
  const remoteTotalInCents = remoteOrderTotal?.totalAmountInCents
  const nextAmountInCents = resolveNextAmountInCents(remoteTotalInCents, remoteOrderTotal, exemptionOverrides)
  const splitTotal = ownProps?.history?.location?.state?.splitTotal
  let total = localOrderTotal

  if (!orderId && isNumber(remoteTotalInCents)) total = nextAmountInCents
  if (splitTotal) total = splitTotal
  if (tenderAmountInCents) total = Math.ceil(tenderAmountInCents)
  const pendingMutation = order.pendingMutation

  return {
    pendingMutation,
    total
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const exemptionOverrides = get(ownProps, 'history.location.state.exemptionOverrides', {})
  const tenderAmountInCents = ownProps?.history?.location?.state?.tenderAmountInCents ?? 0
  const isTenderUpdate = ownProps?.history?.location?.state?.isTenderUpdate ?? false
  const userNotes = ownProps?.history?.location?.state?.userNotes ?? null
  const orderId = head(ownProps?.match?.params?.orderId?.split('?'))
  const queryParams = queryString.parse(get(ownProps, 'location.search', ''))
  const isTab = has(queryParams, 'tab')
  const push = get(ownProps, 'history.push', () => {})
  const goBack = get(ownProps, 'history.goBack', () => {})

  return {
    onBack: () => {
      goBack()
    },
    onComplete: () => {
      if (isTenderUpdate) {
        push(`/receipt/${orderId}/cash-receipt`, { redirectTo: `/tabs/${orderId}` })
      } else if (tenderAmountInCents) {
        dispatch(addTenderOnOrder({ orderId, amountInCents: tenderAmountInCents, useCash: true }))
      } else if (orderId !== undefined) {
        dispatch(applyOrderExemptions(orderId, exemptionOverrides))
        dispatch(startCloseTabOrderWithCash(orderId))
      } else {
        dispatch(startCashOrder({ exemptionOverrides, userNotes }))
      }
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangeCalculatorForm))
